module.exports = __webpack_public_path__ + "static/img/case4.1b018ebd.png";